/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export enum OrderEntriesSource {
  ACTIVE_CART = 'ACTIVE_CART',
  NEW_SAVED_CART = 'NEW_SAVED_CART',
  QUICK_ORDER = 'QUICK_ORDER',
  SAVED_CART = 'SAVED_CART',
  ORDER_CONFIRMATION = 'ORDER_CONFIRMATION',
  ORDER_DETAILS = 'ORDER_DETAILS',
  UNIT_ORDER_DETAILS = 'UNIT_ORDER_DETAILS',
}
